export const Env = {
  PROD: 'production',
  DEV: 'development',
  STAGING: 'staging',
  TESTING: 'testing',
};

const BASE_URL = import.meta.env?.VITE_BACKEND_URL;
if (!BASE_URL) throw new Error('BACKEND_URL not configured');

const SENTRY_DSN = import.meta.env?.VITE_SENTRY_DSN;
if (!SENTRY_DSN) throw new Error('SENTRY_DSN not configured');

const MODE = import.meta.env.MODE;
const ENVIRONMENT = MODE;
console.log(`Running in ${ENVIRONMENT} mode.`);

export { BASE_URL, SENTRY_DSN, ENVIRONMENT };
